import { useState, useEffect, useContext } from "react";
import { EmailTypeContext } from "../context/EmailTypeContext";
import { AnswersContext } from "../context/AnswersContext";
import { DataContext } from "../context/DataContext";
import styled from "styled-components";

const StyledErrorModal = styled.div`
  color: #ed1c24;
  background-color: #f8d9da;
  border: 1px solid #ed1c24;
  max-width: 786px;
  padding: 0.5em;
  display: ${(props) => (!props.display ? "none" : "block")};
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0.5em;
  width: 88.1%;
  z-index: 4;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: none;
  color: #ed1c24;
  font-size: 1.5em;
  cursor: pointer;
`;

const ErrorTitle = styled.h4`
  font-size: 1.3em;
  font-weight: 500;
  display: inline;
`;

const ErrorMessage = styled.p`
  color: #ed1c24;
`;

const ErrorModal = ({
  fetchError,
  otherErrors,
  errors,
  chosenLanguage,
  localizedText,
}) => {
  const { answeredQuestions } = useContext(AnswersContext);
  const { currentPage, messageError, attention } = useContext(DataContext);
  const [display, setDisplay] = useState(false);
  const { emailTypeQuestions } = useContext(EmailTypeContext);

       

  const handleClose = () => {
    window.errorPopped = true;
    setDisplay(false);
  };

  useEffect(() => {
    if (errors?.length || otherErrors?.length) {
      setDisplay(true);
    } else {
      setDisplay(false);
    }
  }, [errors, otherErrors]);

  useEffect(() => {
    if (messageError) {
      setDisplay(true);
    } else if (fetchError) {
      setDisplay(true);
    } else if (!errors?.length && !otherErrors?.length) {
      setDisplay(false);
    }
  });

  let localTranslations = localizedText?.find(
    (localText) => localText.ProjectId === Number.parseInt(chosenLanguage)
  );

  useEffect(() => {
    window.errorPopped = false;
  },[])

  const popError = () => {
    return (
      <StyledErrorModal display={display}>
        {!fetchError && !messageError && (
          <CloseButton onClick={handleClose}>×</CloseButton>
        )}
        <ErrorTitle>
          <strong>⚠</strong>{" "}
          {localTranslations
            ? localTranslations?.Attention
            : attention
            ? attention
            : "Attention"}
        </ErrorTitle>
        {!!(
          !!errors?.length &&
          !!errors.filter(
            (error) => !Object.values(emailTypeQuestions).includes(error)
          )?.length
        ) && (
          <ErrorMessage>
            {localTranslations
              ? localTranslations?.ProvideAnswerRedHighlightedMessage
              : "Please answer the questions in red."}
          </ErrorMessage>
        )}
        {!!otherErrors?.length && <ErrorMessage>{otherErrors[0]}</ErrorMessage>}
        {!!(
          !!errors?.length &&
          !!errors.some((error) =>
            Object.values(emailTypeQuestions).includes(error)
          ) &&
          Object.keys(emailTypeQuestions).some((emailQuestionKey) =>
            answeredQuestions[currentPage - 1]?.some((answeredQuestion) =>
              answeredQuestion.includes(emailQuestionKey)
            )
          )
        ) && (
          <ErrorMessage>
            {localTranslations
              ? localTranslations?.ValidEmailMessage
              : "Please input a valid e-mail address."}
          </ErrorMessage>
        )}
        {messageError ? (
          <ErrorMessage>{messageError.replace(/<BR>/g, " ")}</ErrorMessage>
        ) : fetchError ? (
          <ErrorMessage>
            {localTranslations
              ? localTranslations?.DatabaseRetryError.replace(/<br \/>/g, " ")
              : "There was an error communicating with the server. Please check the survey URL, and refresh to try again."}
          </ErrorMessage>
        ) : (
          ""
        )}
      </StyledErrorModal>
    );
  }

  return (
    !window.errorPopped && popError()
  );
};

export default ErrorModal;
